import React, { ComponentProps, useRef } from 'react'

import { useMegaMenuContext } from './MegaMenuContext'
import { StyledDropdownItem, StyledItemLink } from './styledNavDropdown'

export type NavDropdownMegaMenuItemProps = Omit<
ComponentProps<typeof StyledDropdownItem>,
'container|rowSpacing'
> & {
  title: string
  href?: string
  idx: number
  onTabActive?: () => void
}

export const NavDropdownMegaMenuItem: React.FC<NavDropdownMegaMenuItemProps> = ({ title, children, idx, onTabActive, href = '#', ...props }) => {
  const { setUnderlineStyle, setMenuState } = useMegaMenuContext()
  const dropdownItemRef = useRef<HTMLDivElement>(null)

  const onMouseEnter = () => {
    if (!dropdownItemRef.current) return

    const targetDimensions = dropdownItemRef.current.getBoundingClientRect()
    const parentRect = dropdownItemRef?.current?.parentElement?.getBoundingClientRect() || { left: 0 }

    const { width, left } = targetDimensions
    const leftWithScrollbar = left + window.scrollX - parentRect.left

    setUnderlineStyle({
      width: width,
      left: leftWithScrollbar,
      transform: 'scaleX(1)',
    })

    if (onTabActive) {
      onTabActive()
    }

    setMenuState((prev) => ({
      ...prev,
      tabsActive: idx,
    }))
  }

  return (
    <StyledDropdownItem item
      ref={dropdownItemRef}
      onMouseEnter={onMouseEnter}
      {...props}
    >
      <StyledItemLink variant="body1" href={href}>
        {title}
      </StyledItemLink>
      {children}
    </StyledDropdownItem>
  )
}
